/**
 * Scener — watch-party extension for streaming services
 *
 * Declares a single web-accessible-resource entry covering all `.html`, `.png` and
 * `.js` files, matched to every origin, with no `use_dynamic_url` — so every one of its
 * ~60 bundled files is fetchable from any page at a stable URL.
 *
 * The icon set is the cleanest signal: the files are vendor-named (`ScenerIcon_*.png`)
 * and, being images, load through `probeImage` with no CORS grant — so they survive a
 * restrictive page CSP.
 *
 * Manifest verified against version 7.1.8.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lkhjgdkpibcepflmlgahofcmeagjmecc';

export const scener: ExtensionDefinition = {
  id: ID,
  name: 'Scener',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Exposes all .png / .html / .js files to every origin with no dynamic URL. The vendor-named ' +
    'ScenerIcon images are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-scener-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load ScenerIcon_128.png via <img>. A vendor-named icon exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'ScenerIcon_128.png'),
    },
    {
      id: 'war-scener-icon-512',
      kind: 'web-accessible-resource',
      description:
        'Load ScenerIcon_512.png via <img>. A second vendor-named icon, corroborating ' +
        'the identification and surviving either one being renamed.',
      weight: 0.5,
      run: () => probeImage(ID, 'ScenerIcon_512.png'),
    },
  ],
};
